<template>
  <div class="main">
    <div class="main_header">
        <div class="header_item">
            <span class="header_label">设备名称：</span>
            <el-input v-model="search.bigDeviceName" :size="size" clearable placeholder="请输入设备名称"></el-input>
        </div>
        <div class="header_item">
            <span class="header_label">设备类型：</span>
            <el-select v-model="search.bigType" placeholder="请选择设备类型" clearable>
                <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </div>
      <div class="header_item">
        <span class="header_label">维修时间：</span>
        <el-date-picker
            v-model="search.time"
            type="daterange"
            value-format="yyyy-MM-dd HH:mm:ss"
            :default-time="['00:00:00','23:59:59']"
            range-separator="-"
            start-placeholder="起始时间"
            end-placeholder="结束时间">
        </el-date-picker>
      </div>
      <div class="header_item">
        <el-button icon="el-icon-search" v-if="showButton('search')" @click="searchButtonInfo(true)">查询</el-button>
        <el-button class="search_btn" icon="el-icon-plus" v-if="showButton('insert')" @click="insertProp">新增</el-button>
      </div>
    </div>
    <div class="main_content">
      <el-table
        v-loading="loading"
        :data="dataList"
        height="100%">
        <el-table-column align="center" label="序号" width="60">
          <template #default="scope">
            <span>{{(pageNum - 1) * pageSize + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="bigDeviceName" label="设备名称" align="center" width="150"></el-table-column>
        <el-table-column prop="bigDeviceModel" label="规格型号" align="center" ></el-table-column>
        <el-table-column prop="bigNumber" label="设备编号" align="center" ></el-table-column>
        <el-table-column prop="bigTypeName" label="设备类型" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="strTime" label="开始时间" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="endTime" label="结束时间" align="center" width="150"></el-table-column>
        <el-table-column prop="effectNum" label="影响生产时间（天）" width="150" align="center" ></el-table-column>
        <el-table-column prop="consumeCost" label="维修费用" width="120" align="center" ></el-table-column>
        <el-table-column prop="notes" label="备注" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" align="center" width="200">
          <template #default="{ row }">
            <el-button class="table_btn" size="mini" v-if="showButton('update')" @click="updateProp(row)">修改</el-button>
            <el-button class="delete_btn" size="mini" v-if="showButton('delete')" @click="deleteInfo(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="main_footer">
      <el-pagination
        background
        @current-change="changePageNum"
        @size-change="changePageSize"
        :current-page="pageNum"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </div>
    <el-dialog
      class="prop_dialog"
      :title="asyncTitle? '新增设备维修' :'修改设备维修'"
      :close-on-click-modal="false"
      :visible.sync="asyncVisible"
      width="45%">
      <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="auto" class="rule_form">
        <el-form-item label="设备名称：" prop="bigDeviceId">
          <el-select v-model="ruleForm.bigDeviceId" placeholder="请选择设备名称" clearable @change="changeBigDevice">
            <el-option
                v-for="item in optionsDevice"
                :key="item.bigDeviceId"
                :label="item.bigDeviceName"
                :value="item.bigDeviceId">
            </el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="设备类型：" prop="bigType">
          <el-select v-model="ruleForm.bigType" placeholder="请选择设备类型" :disabled="true">
                <el-option
                v-for="item in optionsType"
                :key="item.dictId"
                :label="item.dictName"
                :value="item.dictId">
                </el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="设备编号：" prop="bigNumber">
          <el-input v-model="ruleForm.bigNumber" :size="size" clearable placeholder="请输入设备编号" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="规格型号：" prop="bigDeviceModel">
          <el-input v-model="ruleForm.bigDeviceModel" :size="size" clearable placeholder="请输入规格型号" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="开始时间：" prop="strTime">
          <el-date-picker
                v-model="ruleForm.strTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择开始时间">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="结束时间：" prop="endTime">
            <el-date-picker
                v-model="ruleForm.endTime"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择结束时间">
            </el-date-picker>
        </el-form-item>
        <el-form-item label="影响生产时间：" prop="effectNum">
            <!-- <el-date-picker
                v-model="ruleForm.effectNum"
                type="date"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="请选择影响生产时间">
            </el-date-picker> -->
            <el-input v-model="ruleForm.effectNum" :size="size" type="number" clearable placeholder="请输入影响生产天数">
              <template slot="append">天</template>
            </el-input>
        </el-form-item>
        <el-form-item label="维修费用：" prop="consumeCost">
          <el-input v-model="ruleForm.consumeCost" :size="size" clearable placeholder="请输入维修费用"></el-input>
        </el-form-item>
        <el-form-item label="附件：" prop="files">
           <upload-file :file-list.sync="ruleForm.files" :disabled="disabled">
                <template #info>
                    <span>点击上传文件，支持xls、xlsx、ppt、doc、docx、pdf格式</span>
                </template>
          </upload-file> 
        </el-form-item>
        <el-form-item label="备注：" prop="notes">
            <el-input v-model="ruleForm.notes" :size="size" type="textarea" :rows="2" clearable placeholder="请输入备注" ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="asyncVisible = false">取 消</el-button>
        <el-button class="submit_btn" @click="asyncTitle ? submitInsert() : submitUpdate()">提 交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UploadFile from '../../components/uploadFile';
import { buttonPinia } from '../../pinia/index';
import { throttle, changeSize } from '../../plugins/public'; // 导入节流、动态切换组件尺寸方法
  export default {
    components:{
       UploadFile
    },
    data() {
      return {
        size: changeSize(), // 组件尺寸
        pageNum: 1,
        pageSize: 10,
        search:{},//查询条件
        total: 0,
        loading: false,
        disabled:false,
        dataList: [], //设备保养信息列表
        asyncTitle: true, // 对话框title 新增：true  修改：false
        asyncVisible: false, // 添加 修改对话框
        ruleForm: {
            files:[]
        }, // 按钮表单
        rules: {
          bigDeviceId: [{
            required: true,
            message: '请输入设备名称',
            trigger: 'blur'
          }],
          bigDeviceModel: [{
            required: true,
            message: '请输入规格型号',
            trigger: 'blur'
          }],
          bigType: [{
            required: true,
            message: '请选择设备类型',
            trigger: 'change'
          }],
          bigNumber: [{
            required: true,
            message: '请输入设备编号',
            trigger: 'blur'
          }],
          strTime: [{
            required: true,
            message: '请选择开始时间',
            trigger: 'change'
          }],
        },
        optionsType:[],//设备类型
        optionsDevice:[],//设备名称
      }
    },
    watch: {
      asyncVisible(bol) {
        if(!bol) {
          this.ruleForm = {};
          this.$refs.ruleForm.resetFields();
        }else{
            this.$set(this.ruleForm,'files',[])
        }
      }
    },
    mounted() {
      const that = this;
      // 根据窗口大小动态修改组件尺寸
      window.onresize = () => {
        that.size = changeSize();
      }
      that.searchButtonInfo(true);
      that.getAllTypes()
      that.getAllDevices()
    },
    methods: {
    //改变设备名称带出不同的信息
    changeBigDevice(val){
        this.$api.Device.detailsBigDevice({bigDeviceId: val}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.$set(this.ruleForm,'bigDeviceModel',res.data.bigDeviceModel)
                this.$set(this.ruleForm,'bigType',res.data.bigType)
                this.$set(this.ruleForm,'bigNumber',res.data.bigNumber)
                this.$set(this.ruleForm,'bigPosition',res.data.bigPosition)
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //获取大型设备下拉
    getAllDevices(){
        this.$api.Device.getAllBigDevice({}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsDevice = res.data
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
    },
    //获取设备类型
      getAllTypes(){
        let params = {
            pageNum: 1,
            pageSize: 100000000,
        }
        this.$api.Dictionary.searchDictionary(params).then(res=>{
            if(res.statusMsg === 'ok'){
                this.optionsType = res.data.list.filter(item=>item.dictType ==='9')
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 查询按钮列表信息
      searchButtonInfo(bol) {
        if(bol) {
          this.pageNum = 1;
        }
        let params = Object.assign({},this.search,{
          pageNum: this.pageNum,
          pageSize: this.pageSize
        })
        params.strTime = this.search.time&&this.search.time[0]
        params.endTime = this.search.time&&this.search.time[1]
        delete params.time
        this.loading = true;
        this.$api.Device.searchServiceDevice(params).then((res) => {
          if(res.statusMsg === 'ok') {
            this.total = res.data.total;
            this.dataList = res.data.list;
          }
          this.loading = false;
        })
      },
      // 新增按钮信息
      insertProp() {
        this.asyncTitle = true;
        this.asyncVisible = true;
        this.ruleForm = {}
      },
      // 修改按钮信息
      updateProp(row) {
        this.asyncTitle = false;
        this.asyncVisible = true;
        this.$api.Device.detailsServiceDevice({bigOverhaulId: row.bigOverhaulId}).then(res=>{
            if(res.statusMsg === 'ok'){
                this.ruleForm = res.data
                this.$set(this.ruleForm, 'files', res.data.overhaulPaths.map((item, index) => {
                    const type = item.overhaulPath.split('.');
                    return {
                        id: index + 1,
                        type: type[type.length - 1],
                        name: item.overhaulPath,
                        url: item.overhaulPath
                    }
                }))
            }else{
                this.$message.warning(res.statusMsg)
            }
        })
      },
      // 删除按钮信息
      deleteInfo(row) {
        this.$confirm("该操作将删除该信息，是否继续删除?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
       })
       .then(() => {
         this.$api.Device.deleteServiceDevice({bigOverhaulId: row.bigOverhaulId})
        .then(res => {
          if(res.statusMsg === 'ok') {
            this.searchButtonInfo(true);
            this.$message.success("删除成功！");
          } else {
            this.$message.warning(res.statusMsg);
          }
        })
       })
       .catch(() => {
         this.$message.warning("您已取消");
       })
      },
      // 提交添加按钮信息
      submitInsert: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.files = params.files&&params.files.map(item => {
               return item.url
            });
            this.$api.Device.insertServiceDevice(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 提交修改按钮信息
      submitUpdate: throttle(function() {
        this.$refs.ruleForm.validate((valid) => {
          if(valid) {
            const params = Object.assign({}, this.ruleForm);
            params.files = params.files&&params.files.map(item => {
               return item.url
            });
            this.$api.Device.updateServiceDevice(params).then((res) => {
              if(res.statusMsg === 'ok') {
                this.asyncVisible = false;
                this.searchButtonInfo(true);
                this.$message.success('添加成功！');
              } else {
                this.$message.warning(res.statusMsg);
              }
            })
          }
        })
      }, 3000),
      // 判断按钮权限信息
      showButton(str) {
        const pinia = buttonPinia();
        return pinia.$state.buttonInfo.includes(str);
      },      
      // 切换页数
      changePageNum(page) {
        this.pageNum = page;
        this.searchButtonInfo();
      },
      // 切换每页条数
      changePageSize(size) {
        this.pageSize = size;
        this.searchButtonInfo();
      }
    }
  }
</script>

<style lang="sass" scoped>
@import '../../style/layout-main.scss';
</style>